import * as types from '../constants';
import initialState from '../initialState';

export default function reducer(state = initialState.role, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: payload.roles,
        totalCount: payload.totalCount,
      };
    case types.SET_ROLES_DETAILS_SUCCESS:
      return {
        ...state,
        details: payload.details,
      };
    case types.GET_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: payload.permissions,
      };
    case types.DELETE_ROLE_SUCCESS:
      return {
        ...state,
        roles: state.roles.filter(({ id }) => id !== payload.id),
        totalCount: state.totalCount - 1,
      };
    default:
      return state;
  }
}
